import { render } from "./Probability.vue?vue&type=template&id=c0d6862a&scoped=true"
import script from "./Probability.vue?vue&type=script&lang=js"
export * from "./Probability.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c0d6862a"

export default script